import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import AddButton from "../../commons/AddButton";

class Estimation_proposal extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }
  render() {
    return (
      <div>
        <BarraSupDent />
        <Title text1="Here is your estimate" />
        <div className="container text-center mt-5">
          <p>
            <b>You repair will cost $.</b>
          </p>
          <p>Can be there by . The repair will take hours</p>
          <p className="mt-5">Does this time work?</p>
          <AddButton text="Yes" />
          <AddButton text="No, find another requested time" />
          <p className="mt-5 pt-5 text-muted">
            Appointments must be confirmed within 24 hours.
            <br />
            Booking for the next morning must be confirmed before 8pm.
          </p>
        </div>
      </div>
    );
  }
}
export default Estimation_proposal;
